export const Amazon = {
    data() {
        return {
            url: process.env.VUE_APP_ASSET_URL
        }
    },

    methods: {
        secure_asset(file) {
            return this.url + '/' + file;
        },
    }
}